// 관리자 필터/검색 툴바 컨테이너.
// 카테고리 셀렉트/검색 입력/액션 버튼 등을 담는 표면 카드. 화면마다 같은 테두리/여백을 쓰게 한다.

import type { ReactNode } from "react";

interface ToolbarProps {
  children: ReactNode;
  className?: string;
}

// 필터 요소들을 담는 표준 툴바 표면.
export default function Toolbar({ children, className }: ToolbarProps) {
  return (
    <div
      className={`flex flex-wrap items-end gap-3 rounded-lg border border-ink-200 bg-surface p-4 ${className ?? ""}`}
    >
      {children}
    </div>
  );
}
